import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '../Typography/Typography';
import { ArrowIcon } from '../../assets/icons/ArrowIcon';
import { IAccordionProps, IContent } from './types';
import classNames from 'classnames/bind';
import styles from './Accordion.module.scss';

const cx = classNames.bind(styles);

const Accordion = ({
  title,
  content,
  icon,
  path,
  isExpanded = false,
  onExpand,
  index,
  currentPath,
  isSelected,
}: IAccordionProps): ReactElement => {
  const baseCurrentPath = currentPath.split('/')[1];

  // Clone the icon element with a new width prop
  const iconWithWidth = React.cloneElement(icon, {
    size: 'small',
    className: styles['icon'],
  });

  const header = (
    <div className={styles['header-container']}>
      <div className={styles['title-container']}>
        {iconWithWidth}
        <Typography className={styles['title']}>{title}</Typography>
      </div>
    </div>
  );

  return (
    <div
      className={cx('accordion-container', {
        'accordion-container-expanded': isExpanded && content.length,
      })}
      key={title}
    >
      <div
        className={cx('accordion', {
          'selected-title': `/${baseCurrentPath}` === path || isSelected,
        })}
        onClick={() => onExpand(index)}
        data-testid={'accordion-header'}
      >
        {path ? (
          <Link className={styles['links']} role="link" to={path}>
            {header}
          </Link>
        ) : (
          header
        )}
        {content.length > 0 && <ArrowIcon className={isExpanded ? styles['arrow-up'] : styles['arrow-down']} />}
      </div>
      {content.length > 0 &&
        isExpanded &&
        content?.map((item: IContent) => (
          <div key={item.label}>
            {item.disabled ? (
              <div className={styles['links']}>
                <Typography className={styles['disabled']} size="XS">
                  {item.label}
                </Typography>
              </div>
            ) : (
              <div className={`/${baseCurrentPath}` === item.path ? styles['selected'] : styles['link-container']}>
                {item.path ? (
                  <Link className={styles['links']} role="link" to={item.path} aria-label={`${title}-link`}>
                    <Typography className={styles['link']} size="XS">
                      {item.label}
                    </Typography>
                  </Link>
                ) : (
                  <div className={styles['links']}>
                    <Typography className={styles['link']} size="XS">
                      {item.label}
                    </Typography>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

export default Accordion;
